import { createEffect, sample } from 'effector';
import $$api from 'models/api';

import AlertsService from 'services/AlertsService';

sample({
    clock: [$$api.originator.addOriginatorFx.failData],
    target: createEffect(AlertsService.handleError),
});
